import { LabelBinding, RequestDataOfSetHvacModeRequest } from '@monorepo-types/dc/smartthermostat';

import { request } from '../../client';
import type { ApiRequestConfig } from '../../client/types';

type SetHvacMode = {
  businessUnit: string;
  label: LabelBinding;
  customerId: number;
  accountId: number;
  locationId: string;
  masterId: string;
  requestBody: RequestDataOfSetHvacModeRequest;
};
/**
 *
 *
 * @returns void
 */
export function setHvacMode(
  { businessUnit, label, customerId, accountId, locationId, masterId, requestBody }: SetHvacMode,
  requestConfig: ApiRequestConfig = {},
): Promise<void> {
  return request(
    {
      method: 'PUT',
      path: `/v1/smartthermostat/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/locations/${locationId}/hosts/${masterId}/hvac`,
      body: requestBody,
      errors: { 400: 'Bad Request', 403: 'Forbidden', 404: 'Not Found', 500: 'Internal Server Error' },
    },
    requestConfig,
  );
}
